import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en_US from "@/locales/en_US/battery_graph";
import zh_CN from "@/locales/zh_CN/battery_graph";
import zh_HK from "@/locales/zh_HK/battery_graph";
import zh_TW from "@/locales/zh_TW/battery_graph";
import ug_CN from "@/locales/ug_CN/battery_graph";
import bo_CN from "@/locales/bo_CN/battery_graph";

const resources = {
  en_US: {
    translation: en_US
  },
  zh_CN: {
    translation: zh_CN
  },
  zh_HK: {
    translation: zh_HK
  },
  zh_TW: {
    translation: zh_TW
  },
  ug_CN: {
    translation: ug_CN
  },
  bo_CN: {
    translation: bo_CN
  }
};
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // lng: "cimode",
    fallbackLng: false,
    // debug: true,
    supportedLngs: ["zh_CN", "en_US", "zh_HK", "zh_TW", "ug_CN", "bo_CN"],
    preload: true,
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    }
    // react: {
    //   wait: true,
    //   useSuspense: false
    // }
  });

export default i18n;

export const setLang = params => {
  let lang = "zh_CN";
  switch (params) {
    case "en_US":
      lang = "en_US";
      break;
    case "zh_TW":
      lang = "zh_TW";
      break;
    case "zh_HK":
      lang = "zh_HK";
      break;
    case "ug_CN":
      lang = "ug_CN";
      break;
    case "bo_CN":
      lang = "bo_CN";
      break;
    default:
      break;
  }
  return lang;
};
